import { render } from "./indexfourbanner.vue?vue&type=template&id=07c93c23"
import script from "./indexfourbanner.vue?vue&type=script&lang=js"
export * from "./indexfourbanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__